import React from 'react';
import { APP_DISPLAY_NAME, APP_VERSION } from '../appMeta';

const LOGO_SRC = `${process.env.PUBLIC_URL || ''}/Logo_CP.svg?v=${encodeURIComponent(APP_VERSION)}`;

export type BrandLogoProps = {
  className?: string;
  /** 접근성·툴팁용 이름 */
  title?: string;
};

/**
 * Class Planner 워드마크 벡터 로고.
 * `currentColor`로 칠해지므로 부모 글자색을 따릅니다.
 */
const BrandLogo: React.FC<BrandLogoProps> = ({
  className,
  title = APP_DISPLAY_NAME,
}) => (
  <span
    className={`cp-brand-logo${className ? ` ${className}` : ''}`}
    role="img"
    aria-label={title}
    title={title}
    style={{
      WebkitMaskImage: `url(${LOGO_SRC})`,
      maskImage: `url(${LOGO_SRC})`,
    }}
  />
);

export default BrandLogo;
